<template>
  <li class="col-span-1">
    <ElTooltip
      :content="description"
      effect="dark"
      :raw-content="true"
      placement="top-start"
    >
      <button
        type="button"
        @click="handleClickWidget"
        class="group w-full flex items-center gap-3 rounded-xl border border-untitled-gray-200 bg-app-white p-4 text-left hover:shadow-sm transition-all"
        :class="statusMeta.hoverBorderClass"
      >
        <div
          class="flex items-center justify-center w-11 h-11 rounded-lg shrink-0"
          :class="statusMeta.iconWrapClass"
        >
          <component :is="statusMeta.icon" class="w-6 h-6" />
        </div>

        <div class="flex-1 min-w-0">
          <p
            class="text-2xl font-bold leading-tight"
            :class="statusMeta.valueClass"
          >
            {{ value }}
          </p>
          <p
            class="text-xs font-medium text-untitled-gray-500 mt-0.5 line-clamp-2"
          >
            {{ text }}
          </p>
        </div>

        <ChevronRightIcon
          class="w-4 h-4 text-untitled-gray-300 shrink-0 transition-colors"
          :class="statusMeta.chevronHoverClass"
        />
      </button>
    </ElTooltip>
  </li>
</template>

<script setup>
import { ElTooltip } from "element-plus";
import { computed, defineProps } from "vue";
import { useRouter } from "vue-router";
import {
  CheckCircleIcon,
  ClockIcon,
  ExclamationCircleIcon,
  ChevronRightIcon,
} from "@heroicons/vue/outline";

const props = defineProps({
  text: {
    type: String,
    default: "",
  },
  value: {
    type: Number,
    default: null,
  },
  description: {
    type: String,
    default: "",
  },
  id: {
    type: String,
  },
});

const router = useRouter();

const text = computed(() => props.text);
const value = computed(() => props.value);
const description = computed(() => props.description);
const id = computed(() => props.id);

const STATUS_META = {
  totalCompleted: {
    icon: CheckCircleIcon,
    iconWrapClass: "bg-app-primary/10 text-app-primary",
    valueClass: "text-app-primary",
    hoverBorderClass: "hover:border-app-primary/40",
    chevronHoverClass: "group-hover:text-app-primary",
  },
  totalInProgress: {
    icon: ClockIcon,
    iconWrapClass: "bg-app-secondary/10 text-app-secondary",
    valueClass: "text-app-secondary",
    hoverBorderClass: "hover:border-app-secondary/40",
    chevronHoverClass: "group-hover:text-app-secondary",
  },
  totalOverdue: {
    icon: ExclamationCircleIcon,
    iconWrapClass: "bg-red-50 text-red-500",
    valueClass: "text-red-500",
    hoverBorderClass: "hover:border-red-300",
    chevronHoverClass: "group-hover:text-red-500",
  },
};

const statusMeta = computed(
  () => STATUS_META[id.value] ?? STATUS_META.totalCompleted
);

const handleClickWidget = () => {
  if (id.value === "totalCompleted") {
    router.push({
      name: "reports",
      query: {
        tab: "assignment-history",
        statuses: ["Completed"],
      },
    });
    return;
  }
  if (id.value === "totalInProgress") {
    router.push({
      name: "reports",
      query: { tab: "assignment-history", statuses: ["In Progress"] },
    });
    return;
  }

  router.push({
    name: "reports",
    query: { tab: "assignment-history", statuses: ["Overdue"] },
  });
};
</script>

<style lang="scss" scoped></style>
